module.exports = __webpack_public_path__ + "media/images/front/review_star_02-e7fd061f8d1c6a0e4ea3014134313ad4.png";